import { Button, Typography } from "@joonapp/web-shared"
import { toast } from "react-hot-toast"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import { CloseButton } from "../../../components/closeButton/CloseButton"
import SlideUpModal from "../../../components/slideUpModal/SlideUpModal"
import { useRedeemAllQuestRewardsMutation } from "../../../networking/quests/mutations"
import useFamilyUserSelectStore from "../hooks/useFamilyUserSelect"

interface useConfirmRedeemChildRewardModalStoreProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useConfirmRedeemChildRewardModalStore =
  create<useConfirmRedeemChildRewardModalStoreProps>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  }))

const ConfirmRedeemChildRewardModal = () => {
  const { selectedUserId } = useFamilyUserSelectStore()
  const { isOpen, onClose } = useConfirmRedeemChildRewardModalStore()
  const redeemQuestRewardMutation = useRedeemAllQuestRewardsMutation()
  const { t } = useTranslation()

  const handleRedeem = async () => {
    if (!selectedUserId) return
    await redeemQuestRewardMutation.mutateAsync({
      userId: selectedUserId,
    })
    toast.success(t("CT_REDEEM_SUCCESS"))
    onClose()
  }

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
    >
      <CloseButton onClick={onClose} />
      <div className="flex flex-col p-4 gap-4">
        <Typography variant="h4">{t("CT_CONFIRM_TITLE")}</Typography>
        <Typography variant="bodySmall">{t("CT_CONFIRM_DESC_1")}</Typography>
        <img
          src="/images/redeem_from_mailman.png"
          alt="redeem-from-mailman"
          className="w-full"
        />
        <Typography variant="bodySmall">{t("CT_CONFIRM_DESC_2")}</Typography>
        <div className="flex gap-2">
          <Button
            buttonType="secondary"
            fullWidth
            text={t("QB_CANCEL")}
            onClick={onClose}
            disabled={redeemQuestRewardMutation.isLoading}
          />
          <Button
            buttonType="primary"
            fullWidth
            text={t("CT_REDEEM")}
            onClick={handleRedeem}
            isLoading={redeemQuestRewardMutation.isLoading}
          />
        </div>
      </div>
    </SlideUpModal>
  )
}

export default ConfirmRedeemChildRewardModal
